export default __webpack_public_path__ + "static/media/dribble-logo.0ef4daef.svg";